(() => {
  // The asset may be rendered more than once when a page has multiple sections.
  if (!window.motionGreyCaseStudies) {
    const initializeSection = (root) => {
      if (root.dataset.mgInitialized) return;
      root.dataset.mgInitialized = 'true';
      const dialog = root.querySelector('[data-mg-dialog]');
      const fullPhoto = root.querySelector('[data-mg-full-photo]');
      const caption = root.querySelector('[data-mg-photo-caption]');
      const heroPhoto = root.querySelector('[data-mg-hero-photo]');
      const heroImage = root.querySelector('[data-mg-hero-image]');
      const heroCaption = root.querySelector('[data-mg-hero-caption]');
      const slideButtons = Array.from(root.querySelectorAll('[data-mg-slide]'));
      let photoTrigger;

      root.querySelectorAll('[data-mg-photo]').forEach((button) => {
        button.addEventListener('click', () => {
          photoTrigger = button;
          fullPhoto.src = button.dataset.mgPhoto;
          fullPhoto.alt = button.querySelector('img').alt;
          caption.textContent = button.dataset.caption;
          if (!dialog.open) dialog.showModal();
        });
      });
      root.querySelector('[data-mg-close-photo]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        if (photoTrigger?.isConnected) photoTrigger.focus({ preventScroll: true });
      });
      // Escape and focus trapping are provided by the native modal dialog.
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      slideButtons.forEach((button) => {
        button.addEventListener('click', () => {
          heroPhoto.dataset.mgPhoto = button.dataset.src;
          heroPhoto.dataset.caption = button.dataset.caption;
          heroImage.src = button.dataset.src;
          heroImage.alt = button.dataset.alt;
          const index = String(button.dataset.mgSlide).padStart(2, '0');
          const total = String(slideButtons.length).padStart(2, '0');
          heroCaption.replaceChildren(document.createTextNode(`${index} / ${total} `));
          const label = document.createElement('span');
          label.textContent = button.dataset.label;
          heroCaption.append(label);
          slideButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
    };
    const initialize = (scope) => {
      if (scope.matches?.('[data-mg-case-study]')) initializeSection(scope);
      scope.querySelectorAll('[data-mg-case-study]').forEach(initializeSection);
    };
    window.motionGreyCaseStudies = { initialize };
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.motionGreyCaseStudies.initialize(document), { once: true });
  } else {
    window.motionGreyCaseStudies.initialize(document);
  }
})();
